import {IhioWrittenPrescriptionItemType} from "../../../../../types/ihioPrescriptionFilling";
import {isPastDay, MtoJDateFormat} from "../../../../../utils/date";
import Tooltip from "../../../general/tooltip";
import Icon from "../../../general/icon";

type WrittenPrescriptionItemCardProps = {
    item: IhioWrittenPrescriptionItemType;
    creationDate?: string;
    isReadyToFulfil?: boolean;
    handleAddItemToFulfil: (UUID: string, item: IhioWrittenPrescriptionItemType) => void
    handleRemoveItemFromFulfil: (UUID: string) => void
}

const WrittenPrescriptionItemCard = ({
    item,
    creationDate,
    isReadyToFulfil,
    handleAddItemToFulfil,
    handleRemoveItemFromFulfil
}: WrittenPrescriptionItemCardProps) => {

    const determineRemainingItems = () => {
        return item?.deliveredItems?.reduce((sum, item) => {
            return sum + (item.itemCount || 0);
        }, 0);
    }

    return (
        <div className={`card shadow-none border rounded-4 ${determineRemainingItems() === item?.itemCount ? 'border-green-success bg-light-green-success' : ''} 
                            ${(item?.activeDate && !isPastDay(item?.activeDate, new Date(new Date().setHours(0, 0, 0, 0)))) ? 'bg-gray-100' : ''}`}>
            <div className={'card-body'}>
                <div className={'d-flex align-items-center justify-content-between'}>
                    <div>
                        {item?.activeDate ? MtoJDateFormat(item?.activeDate) : creationDate?.slice(0, 10) || ''} - {item?.itemCount || 0} عدد - {determineRemainingItems()} عدد تحویل داده شده
                    </div>
                    <bdi className={'d-flex align-items-center gap-3'}>
                        {determineRemainingItems() === item?.itemCount ? (
                            <Tooltip alt={'تحویل داده شده است'}>
                                <span className={'text-green2'}>
                                    <Icon name={'check-square'}/>
                                </span>
                            </Tooltip>
                        ) : (item?.activeDate && !isPastDay(item?.activeDate, new Date(new Date().setHours(0, 0, 0, 0)))) ? (
                            <Tooltip alt={'این نسخه برای آینده می‌باشد و قابل ارائه نمی‌باشد'}>
                                <span className={'text-purple'}>
                                    <Icon name={'info-circle'}/>
                                </span>
                            </Tooltip>
                        ) : (
                            <Tooltip alt={'ارائه خدمت'}>
                                <span>
                                    <button
                                        className={`btn  btn-sm rounded rounded-circle px-2 py-1 ${isReadyToFulfil ? 'btn-danger' : 'btn-primary'}`}
                                        // icon={isReadyToFulfil ? CrossIcon : PlusIcon}
                                        // iconClassName={'svg-icon-1'}
                                        onClick={() => isReadyToFulfil ? handleRemoveItemFromFulfil(item?.UUID || '') : handleAddItemToFulfil(item?.UUID || '', item)}
                                    >
                                        <Icon name={isReadyToFulfil ? 'close-square' : 'add-square'}/>
                                    </button>
                                </span>
                            </Tooltip>
                        )}
                        <div
                            className={'badge badge-primary px-2 py-2'}
                            title={item?.irc || ''}
                        />
                        <bdi>
                            {item?.name}
                        </bdi>
                    </bdi>
                </div>
                {item?.description && (
                    <div className={'d-flex align-items-center mb-3'}>
                        <span className={'text-gray-600 me-3'}>
                            توضیحات:
                        </span>
                        <span className={'text-gray-900'}>
                            {item?.description}
                        </span>
                    </div>
                )}
            </div>
        </div>
    )
}


export default WrittenPrescriptionItemCard;